// extracted by mini-css-extract-plugin
export default {"container":"app_container__UGnJY","label":"app_label__N0Q6G","input":"app_input__27mc1","error":"app_error__tt8l7","w50":"app_w50__kD+G4","checkbox":"app_checkbox__H4P3g"};